import { DATE_FORMAT, ID_DATE_FORMAT, JP_DATE_FORMAT, localeMap, ZH_DATE_FORMAT } from 'app/modules/Constants';
import Helper from 'app/modules/Helper';
import { format, Locale } from "date-fns";

export function formattedDateString({ date, lng }: { date: Date; lng: string }) {
	const langCode = Helper.getLanguageCode(lng);
	let dateDisplayFormat = DATE_FORMAT;
	if (langCode === 'jp') {
		dateDisplayFormat = JP_DATE_FORMAT;
	} else if (langCode === 'id') {
		dateDisplayFormat = ID_DATE_FORMAT;
	} else if (langCode === 'zh') {
		dateDisplayFormat = ZH_DATE_FORMAT;
	}
	const isKorean = langCode === 'ko';
	const isSwedish = langCode === 'sv';
	const isRussian = langCode === 'ru';
	let formattedDate = format(date, dateDisplayFormat, { locale: localeMap[lng] });
	if (isRussian) {
		formattedDate = formattedDate.slice(0, 2) + formattedDate.slice(3);
	}
	if (isKorean) {
		formattedDate += '일';
	}

	let renderText: string | React.ReactNode = (
		<span style={{ textTransform: 'capitalize' }}>{formattedDate}</span>
	);

	if (isSwedish) {
		// Capitalize day, lowercase month
		renderText = formattedDate.replace(
			/(\D+),\s(\D+)/,
			(_, day, month) => `${day.charAt(0).toUpperCase() + day.slice(1)}, ${month.toLowerCase()}`
		);
	}

	return { ariaLabelString: formattedDate, renderText };
}
/**
 * Formats a date string with proper weekday abbreviations for different languages
 * For Russian, uses 2-letter weekday abbreviations instead of the default 3-letter ones
 * @param date - Date
 * @param locale - Locale object
 * @returns Formatted date string with weekday, day and month
 */
export function getFormattedWeekDate(date: Date, locale?: Locale) {
	if (locale?.code === 'ru') {
		// Russian 2-letter weekday abbreviations
		const russianWeekdays = ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб']
		const weekday = russianWeekdays[date.getDay()]
		return weekday
	} else {
		// For other languages, use the standard format
		return format(date, 'EEE', { locale })
	}
}
